import React from "react";
import {
  Box,
  Button,
  Chip,
  Grid,
  Paper,
  Typography,
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ConstructionIcon from "@mui/icons-material/Construction";
import { Link } from "react-router-dom";

function LearningModulePage({
  title,
  eyebrow,
  description,
  icon: Icon,
  color,
  bg,
  items = [],
}) {
  return (
    <Box sx={{ width: "100%", mt: 4, mb: 6 }}>
      <Box component="header" sx={{ maxWidth: 840 }}>
        <Chip
          size="small"
          icon={<ConstructionIcon sx={{ fontSize: "16px !important" }} />}
          label={eyebrow}
          sx={{ mb: 1.5, bgcolor: bg, color, fontWeight: 700 }}
        />
        <Typography
          component="h1"
          sx={{
            color: "var(--toeic-ink-deep)",
            fontSize: { xs: 36, md: 56 },
            fontWeight: 800,
            letterSpacing: 0,
            lineHeight: 1.04,
          }}
        >
          {title}
        </Typography>
        <Typography
          sx={{
            mt: 1.5,
            color: "var(--toeic-ink-soft)",
            fontSize: 18,
            fontWeight: 400,
            lineHeight: 1.65,
          }}
        >
          {description}
        </Typography>
      </Box>

      <Box sx={{ mt: 4, mb: 4, borderTop: "1.5px dotted var(--toeic-line)" }} />

      <Paper
        elevation={0}
        sx={{
          p: { xs: 2.5, md: 3 },
          borderRadius: "14px",
          bgcolor: "var(--toeic-surface)",
          boxShadow: "var(--toeic-shadow-card)",
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, mb: 3 }}>
          <Box
            sx={{
              width: 56,
              height: 56,
              borderRadius: "14px",
              display: "grid",
              placeItems: "center",
              bgcolor: bg,
              color,
            }}
          >
            <Icon sx={{ fontSize: 34 }} />
          </Box>
          <Box>
            <Typography sx={{ color: "var(--toeic-ink-deep)", fontWeight: 700 }}>
              Roadmap
            </Typography>
            <Typography sx={{ color: "var(--toeic-ink-soft)", fontWeight: 400 }}>
              This module is ready in navigation and waiting for its first feature set.
            </Typography>
          </Box>
        </Box>

        <Grid container spacing={2}>
          {items.map((item) => (
            <Grid item xs={12} md={4} key={item}>
              <Box
                sx={{
                  p: 2,
                  minHeight: 104,
                  borderRadius: "14px",
                  bgcolor: "var(--toeic-paper-grid)",
                  border: "1.5px dotted var(--toeic-line)",
                }}
              >
                <Typography sx={{ color: "var(--toeic-ink)", fontWeight: 700 }}>
                  {item}
                </Typography>
              </Box>
            </Grid>
          ))}
        </Grid>

        <Button
          component={Link}
          to="/"
          startIcon={<ArrowBackIcon />}
          sx={{ mt: 3, color: "var(--toeic-sky-deep)", fontWeight: 700 }}
        >
          Back to Lingualica
        </Button>
      </Paper>
    </Box>
  );
}

export default LearningModulePage;
